'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { REWARDS_TIERS } from '~/components/Account/Rewards/RewardsTiers.config';
import { api } from '~/libs/api';
const TIER_STALE_TIME = 5 * 60_000;

/**
 * Single source for the panel's tier line. The tier is stamped into Clerk privateMetadata,
 * which the client cannot read, so it comes over tRPC — but only once the menu is open, since
 * react-aria doesn't mount the panel's children until then. Swapping to a session claim or a
 * publicMetadata mirror would only change this hook.
 */
export function useAccountTier(isEnabled) {
  const $ = _c(7);
  const t = useTranslations("account");
  const isRewardsEnabled = process.env.NEXT_PUBLIC_FF_REWARDS_ENABLED === "true";
  const t0 = isEnabled && isRewardsEnabled;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0,
      staleTime: TIER_STALE_TIME
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: customer
  } = api.account.loyaltyStatus.useQuery(undefined, t1);
  if (!customer || customer.tier === "None") {
    return null;
  }
  let t2;
  if ($[2] !== customer || $[3] !== t) {
    let t3;
    if ($[5] !== customer) {
      t3 = t4 => {
        const {
          tierId
        } = t4;
        return tierId === customer.tierId;
      };
      $[5] = customer;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const tier = REWARDS_TIERS.find(t3);
    t2 = t("menu_tier_label", {
      tier: tier ? t(tier.nameKey) : customer.tier
    });
    $[2] = customer;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}